import { Injectable } from '@angular/core'
import { Http, Response, Headers, URLSearchParams } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import { SettingsService } from './settings.service'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'
import 'rxjs/add/observable/empty'
import { SessionService } from './session.service'
import { doesNotThrow } from 'assert';

@Injectable()
export class RequestService {
	public _headers: Headers

	public base_uri = ''
	public authorization = ''
	public access_token = ''
	public backend_uri = "https://api.stunii.com/"
	// public backend_uri = "http://localhost:50117/";
	constructor(private _http: Http, private sessionService: SessionService, private settings: SettingsService) {
		this.base_uri = settings.apiURL
		// this.base_uri = "http://localhost:50117/";
		// this.authorization = btoa('admin_app:4C0k8u3YVI3q')
		this._headers = new Headers()
		this._headers.set('Content-Type', 'application/json')
		this.buildHeaders()
	}

	buildHeaders() {
		this._headers.set('access_token', this.sessionService.access_token)
		switch (this.sessionService.userType) {
			case 'admin':
				this._headers.set('Authorization', 'Basic ' + btoa('admin_app:4C0k8u3YVI3q'))
				break
			case 'provider':
				this._headers.set('Authorization', 'Basic ' + btoa('provider_app:606Z0ha60W2n'))
				break
			default:
				this._headers.delete('Authorization')
				break
		}
	}

	get(uri: any, params?: Object): Observable<any> {
		this.buildHeaders()
		uri = typeof uri === 'object' ? uri.join('/') : uri
		return this._http.get(this.base_uri + uri, { body: '', headers: this._headers, search: this.objToGet(params) })
			.map(this.extractData)
			.catch(this.handleError)
	}

	post(uri: any, params: Object = {}): Observable<any> {
		this.buildHeaders()
		uri = typeof uri === 'object' ? uri.join('/') : uri
		return this._http.post(this.base_uri + uri, JSON.stringify(params), { headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	postWithFiles(uri: string, files: FileList): Observable<any> {
		// TODO: - Sredi svinjariju
		return Observable.create(observer => {
			const formData: FormData = new FormData()
			const xhr: XMLHttpRequest = new XMLHttpRequest()
			for (let i = 0; i < files.length; i++) {
				formData.append('files[]', files[i], files[i].name)
			}

			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						observer.next(JSON.parse(xhr.response))
						observer.complete()
					} else {
						observer.error(xhr.response)
					}
				}
			}
			xhr.open('POST', this.base_uri + uri, true)
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
			xhr.setRequestHeader('access_token', this.sessionService.access_token)
			xhr.setRequestHeader('Authorization', 'Basic ' + localStorage.getItem('stus_auth'))
			xhr.send(formData)
		})
	}

	put(uri: any, params: Object = {}): Observable<any> {
		this.buildHeaders()
		uri = typeof uri === 'object' ? uri.join('/') : uri
		return this._http.put(this.base_uri + uri, JSON.stringify(params), { headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	remove(uri: any, params?: Object): Observable<any> {
		this.buildHeaders()
		uri = typeof uri === 'object' ? uri.join('/') : uri
		return this._http.delete(this.base_uri + uri, { headers: this._headers, search: this.objToGet(params) })
			.map(this.extractData)
			.catch(this.handleError)
	}

	private extractData = (res: Response) => {

		if (res.status < 200 || res.status >= 300) {
			throw new Error('Bad response status: ' + res.status)
		}

		const body = res.json()
		if (body.success === false) {
			throw new Error(body.message)
		}
		return body || {}
	}

	private handleError = (error: any) => {
		// return Observable.empty()
		let message: string
		if (parseInt(error.status, 10) === 401) {
			this.sessionService.logout()
			this.sessionService.logoutProvider()
		} else {
			message = error._body ? JSON.parse(error._body) : error.message

		}
		// return false
		// return Observable.empty()
		return Observable.throw(message)
	}

	objToGet(o): URLSearchParams {
		const tmpParams = new URLSearchParams()
		for (const key in o) {
			if (o.hasOwnProperty(key)) {
				tmpParams.set(key, o[key])
			}
		}
		return tmpParams
	}

	//QRcode post api
	QRcodeGenerator(params: Object = {}): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'genQRcode', { params, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
//QRcode dwonload api
	QRDownload(params: Object = {}): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'downloadQR', { params, header: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

//Premium upload post api
	premiumUpload(data): Observable<any> {
		let newdata = new FormData();
		newdata.append('userid', data.userid);
		newdata.append('list', data.list);
		newdata.append('photo', data.image);
		return this._http.post(this.backend_uri + 'api/upload', newdata)
			.map(this.extractData)
			.catch(this.handleError)
	}
//Premium to get all premium api
	allPremium(): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'isPremiumuser', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}


	allPremiumRedemptions(): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'redemptions', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	allPremiumUnsubscriptions(): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'premiumUnsub', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getPremium(): Observable<any> {
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'imagedownload', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	searchPremiumRedemption(username): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'searchPremRed', {username, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	premiumUnsubSearch(username): Observable<any>{
		this.buildHeaders()
		return this._http.post(this.backend_uri+'searchUnsub',{username,headers: this._headers})
				 .map(this.extractData)
				 .catch(this.handleError)
	}

	premiumUserSearch(username): Observable<any>{
		this.buildHeaders()
		return this._http.post(this.backend_uri+'searchPrem',{username,headers: this._headers})
				  .map(this.extractData)
				  .catch(this.handleError)
	}


	/* 16-3-2019 unimited redemptin referral optins */
	
	allUnlimitedRedemptions(): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'getReference', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	searchUnlimitedRedemption(referalname): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'serachByReferal', {referalname, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	subCategories(subData): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'subCategory', {subData, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getSubCategories(subData): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'getSubCategory', {subData, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	
	
	allJobs(): Observable<any> {
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'allJobs', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	updateJob(data): Observable<any> {
		let newdata = new FormData();
		newdata.append('jobId',data.jobId);
		newdata.append('jobName', data.jobName);
		newdata.append('jobAddress', data.jobAddress);
		newdata.append('jobType', data.jobType);
		newdata.append('jobDescription', data.jobDescription);
		newdata.append('companyName', data.companyName);
		newdata.append('companyEmail',data.companyEmail);
		newdata.append('companyImage', data.companyImage);
		newdata.append('jobRate', data.jobRate);
		return this._http.post(this.backend_uri + 'editJob', newdata)
			.map(this.extractData)
			.catch(this.handleError)
	}

	deleteJob(jobId): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'deleteJob',{jobId, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}


	addJob(data): Observable<any> {
		let newdata = new FormData();
		newdata.append('jobName', data.jobName);
		newdata.append('jobAddress', data.jobAddress);
		newdata.append('jobType', data.jobType);
		newdata.append('jobDescription', data.jobDescription);
		newdata.append('companyName', data.companyName);
		newdata.append('companyEmail',data.companyEmail);
		newdata.append('companyImage', data.companyImage);
		newdata.append('jobRate', data.jobRate);
		return this._http.post(this.backend_uri + 'createJob', newdata)
			.map(this.extractData)
			.catch(this.handleError)
	}

	getJob(jobId): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'jobDetail', { jobId,headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}


	
	getAllSub(): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'allSubCategory', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	deleteSub(subId): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'deleteSubCategory', { subId, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	demandDeals(): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'allDemandDeals', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	demandDelete(demandId): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'demandDelete?demandId='+demandId, { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	referralToDelete(referral_id): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'deleteReferralTo?referral_id='+referral_id, { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	referralFromDelete(referral_id): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'deleteReferralFrom?referral_id='+referral_id, { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getReferralFrom(): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getReferralFrom', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getReferralTo(): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getReferralTo', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	addReferralTo(referral_to): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'addReferralTo', { referral_to, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	addReferralFrom(referral_from): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'addReferralFrom', { referral_from, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	addTaxi(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'addTaxi', { data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getTaxi(): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getTaxi', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	deleteTaxi(taxi_id): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'deleteTaxi',{taxi_id, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getTaxiDetail(taxi_id): Observable<any> {
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getTaxiDetail?taxi_id='+taxi_id,{body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)	
	}
	
	updateTaxi(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'updateTaxi',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	getPremiumOffer(){
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getPremiumOffer',{body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)	
	}

	deletePremiumOffer(premium_id): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'deletePremiumOffer',{premium_id, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	
		
	createPremiumOffer(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'createPremiumOffer',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	
	offerPremium(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'offerPremium',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	

	updatePremiumOffer(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'updatePremiumOffer',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	createCoupan(data):Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'createCoupan',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	
	getCoupan():Observable<any> {
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'getCoupan',{body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)	
	}

	deleteCoupan(coupan_id): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'deleteCoupan',{coupan_id, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	
	saveDynamicText(dynamic): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'dynamic_text',{dynamic, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	
	editCoupan(coupan_id): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'editCoupan',{coupan_id, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	updateCoupan(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'updateCoupan',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	editSubCategory(subCategory_id): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'editSubCategory',{subCategory_id, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	updateSubCategory(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'updateSubCategory',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}

	allKeyworkers(data):Observable<any> {

		this.buildHeaders()
		return this._http.post(this.backend_uri + 'get-keyworkers',data)
			.map(this.extractData)
			.catch(this.handleError)	
	}
	
	deleteKeyworker(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'remove-keyworker',{data, headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
	
		
	addKeyworker(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'keyworker-signup',data)
			.map(this.extractData)
			.catch(this.handleError)
	}

	
	getKeyworker(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'keyworker-detail',data)
			.map(this.extractData)
			.catch(this.handleError)
	}
	
	editKeyworker(data): Observable<any> {
		this.buildHeaders()
		return this._http.post(this.backend_uri + 'update-keyworker',data)
			.map(this.extractData)
			.catch(this.handleError)
	}
	
	changeStatus(data): Observable<any> {

		this.buildHeaders()
		return this._http.post(this.backend_uri + 'approve-disapprove-keyworker',data)
			.map(this.extractData)
			.catch(this.handleError)
	}

	keyworkers(): Observable<any>{
		this.buildHeaders()
		return this._http.get(this.backend_uri + 'countKeyworker', { body: '', headers: this._headers })
			.map(this.extractData)
			.catch(this.handleError)
	}
}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/services/request.service.ts